import { Tooltip } from '@mui/material'
import styled from 'styled-components/macro'

import { spacing } from 'src/utils/styled'

const IconWrapper = styled.span`
    margin-right: ${spacing(1)};
    cursor: pointer;

    display: flex;
    align-items: center;
`

type IconProps = {
    tooltip?: React.ReactNode
    children: React.ReactNode
}

export function Icon({ tooltip, children }: IconProps) {
    return (
        <Tooltip title={tooltip} placement="top">
            <IconWrapper>{children}</IconWrapper>
        </Tooltip>
    )
}
